import { Children, type PropsWithChildren } from 'react'

import { Layout, Text } from '@loadsmart/miranda-react'

import { DocumentEmptyState } from './DocumentEmptyState'

export type DocumentSectionProps = PropsWithChildren<{
  name: string
}>

export function DocumentSection({ name, children }: DocumentSectionProps) {
  return (
    <Layout.Stack data-testid={`${name}-section`}>
      <Text variant="body-sm-bold" color="color-neutral-60">
        {name.toUpperCase()}
      </Text>
      <Layout.Stack>
        {Children.count(children) > 0 ? children : <DocumentEmptyState />}
      </Layout.Stack>
    </Layout.Stack>
  )
}
